import React from 'react';
import { OrderItem } from '../types';
import ProductAttrs from './ProductAttrs';
import './OrderItemsModal.css';

const UNIT_LABELS: Record<string, string> = { PIECE: 'шт.', METER: 'м.', KG: 'кг.' };

const fmt = (n: number) =>
  Number(n).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

interface Props {
  orderId: number;
  items: OrderItem[];
  onClose: () => void;
}

const OrderItemsModal: React.FC<Props> = ({ orderId, items, onClose }) => {
  const total = items.reduce((s, i) => s + i.quantity * Number(i.unitPrice), 0);

  return (
    <div className="oim-overlay" onClick={onClose}>
      <div className="oim-modal" onClick={(e) => e.stopPropagation()}>
        <div className="oim-header">
          <h3>Заказ #{orderId} — товары</h3>
          <button className="oim-close" onClick={onClose}>×</button>
        </div>
        <div className="oim-body">
          <table className="oim-table">
            <thead>
              <tr>
                <th>Товар</th>
                <th>Кол-во</th>
                <th>Цена</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => {
                const unit = UNIT_LABELS[item.product?.unit ?? ''] ?? '';
                const subtotal = item.quantity * Number(item.unitPrice);
                return (
                  <tr key={item.id}>
                    <td className="oim-name">
                      {item.product?.name ?? `Товар #${item.productId}`}
                      <ProductAttrs attributes={item.product?.attributes} />
                    </td>
                    <td className="oim-qty">{item.quantity} {unit}</td>
                    <td className="oim-price">{fmt(item.unitPrice)} сом</td>
                    <td className="oim-sub">{fmt(subtotal)} сом</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="oim-footer">
          <span>Итого: <strong>{fmt(total)} сом</strong></span>
        </div>
      </div>
    </div>
  );
};

export default OrderItemsModal;
